// extracted by mini-css-extract-plugin
export default {"list":"ProblemProductList_list__KxPMs"};